// bm-design-system: chat date separator primitive
import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * A centered, sticky day divider between chat messages that cross a calendar day
 * ("Hari ini" · "Kemarin" · an explicit date). The `label` is precomputed by the
 * caller from a SERVER-provided reference date (not the client clock), so this
 * primitive holds no clock and renders identically across SSR and hydration.
 *
 * Sticks to the top of the scroll region so the current day stays visible while
 * scrolling that day's run of messages.
 */
export interface DateSeparatorProps {
  label: string;
  className?: string;
}

const DateSeparator = React.forwardRef<HTMLDivElement, DateSeparatorProps>(
  ({ label, className }, ref) => {
    return (
      <div ref={ref} className={cn("chat-day-separator", className)} role="separator" aria-label={label}>
        <span className="chat-day-separator-label">{label}</span>
      </div>
    );
  },
);
DateSeparator.displayName = "DateSeparator";

export { DateSeparator };
